export default __webpack_public_path__ + "static/media/sunny.bbbee777.svg";